import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware } from 'redux-observable';
import { reducers } from './reducers';
import { rootEpic } from './epics';
import { PersistConfig, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const epicMiddleware = createEpicMiddleware();

const middleware = [epicMiddleware];

const persistConfig: PersistConfig = {
  key: 'deliverer',
  storage: storage,
  whitelist: ['app', 'auth']
};

const configureStore = () => {
  const store = createStore(
    persistReducer(persistConfig, combineReducers(reducers)),
    composeWithDevTools(applyMiddleware(...middleware))
  );

  epicMiddleware.run(rootEpic);
  const persistor = persistStore(store);

  return { store, persistor };
};

export default configureStore;
